import { render, staticRenderFns } from "./CampaignRecordsModal.vue?vue&type=template&id=d5f2a0f4&scoped=true&"
import script from "./CampaignRecordsModal.vue?vue&type=script&lang=js&"
export * from "./CampaignRecordsModal.vue?vue&type=script&lang=js&"
import style0 from "./CampaignRecordsModal.vue?vue&type=style&index=0&id=d5f2a0f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f2a0f4",
  null
  
)

export default component.exports